import { createAction, props } from "@ngrx/store";
import ISkillNodeWithRating from "@skills-app/models/skillNodeWithRating";

const prefix = "[Add User Skill Dialogue]";

export const selectAddSkillUser = createAction(
  `${prefix} Seleted User For Adding A User Skill`,
  props<{ azureId: string }>(),
);
export const selectSkill = createAction(
  `${prefix} Select Skill`,
  props<{ skillId: string }>(),
);
export const requestUpdateUserSkill = createAction(
  `${prefix} Request Update User Skill`,
  props<{ azureId: string; skillMapping: ISkillNodeWithRating }>(),
);
export const clearSelectedSkill = createAction(
  `${prefix} Clear Selected Skill`,
);
